import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DialogPatientComponent } from './components/dialog-patient/dialog-patient.component';
import { PatientsListComponent } from './components/patients-list/patients-list.component';
import { DialogRecordComponent } from './components/dialog-record/dialog-record.component';
import { SearchComponent } from './components/search/search.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { UploaderComponent } from './components/uploader/uploader.component';
import { AttachmentsComponent } from './components/attachments/attachments.component';
import { AttachmentComponent } from './components/attachment/attachment.component';
import { DialogImageViewerComponent } from './components/dialog-image-viewer/dialog-image-viewer.component';
import { FileSaverModule } from 'ngx-filesaver';
import { ClickOutsideModule } from 'ng-click-outside';
import { ProfilePictureComponent } from './components/profile-picture/profile-picture.component';
import { AgeFormFieldComponent } from './components/age-form-field/age-form-field.component';
import { SpeciesFormFieldComponent } from './components/species-form-field/species-form-field.component';
import { BreedFormFieldComponent } from './components/breed-form-field/breed-form-field.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { HeaderPrimaryComponent } from './components/header-primary/header-primary.component';
import { PatientInfoComponent } from './components/patient-info/patient-info.component';
import { AnimateWithScrollDirective } from './directives/animate-with-scroll.directive';
import { HeaderComponent } from './components/header/header.component';
import { LayoutModule } from '@angular/cdk/layout';

export const sharedComponents = [
  DialogPatientComponent,
  PatientsListComponent,
  DialogRecordComponent,
  SearchComponent,
  AvatarComponent,
  UploaderComponent,
  AttachmentsComponent,
  AttachmentComponent,
  DialogImageViewerComponent,
  ProfilePictureComponent,
  AgeFormFieldComponent,
  SpeciesFormFieldComponent,
  BreedFormFieldComponent,
  HeaderPrimaryComponent,
  PatientInfoComponent,
  HeaderComponent
];

export const sharedDirectives = [
  AnimateWithScrollDirective
];

export const sharedModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatCardModule,
  MatIconModule,
  MatToolbarModule,
  MatSidenavModule,
  MatMenuModule,
  MatDialogModule,
  MatSnackBarModule,
  MatDividerModule,
  MatListModule,
  MatTableModule,
  MatRippleModule,
  MatProgressBarModule,
  MatAutocompleteModule,
  MatProgressSpinnerModule,
  MatExpansionModule,
  MatRadioModule,
  MatSelectModule,
  MatChipsModule,
  ScrollingModule,
  TextFieldModule,
  FileSaverModule,
  ClickOutsideModule,
  MatGridListModule,
  MatTabsModule,
  LayoutModule
];

@NgModule({
  declarations: [
    ...sharedComponents,
    ...sharedDirectives
  ],
  imports: [
    ...sharedModules
  ],
  exports: [
    ...sharedModules,
    ...sharedComponents,
    ...sharedDirectives
  ]
})
export class SharedModule { }
